import styled from "styled-components";

export const ShowcaseContainer = styled.div`
	justify-content: center;
	align-items: center;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100vh;
`;

export const Emot = styled.img`
	width: 10rem;
`;

export const Image = styled.img`
	border-radius: 0.5rem;
	overflow: hidden;
`;
